import React from 'react';
import { Spin, SpinProps } from 'antd';
import styles from './styles.module.pcss';
import { AryaLoading } from '@/components';

const Loader: React.FC<SpinProps> = ({ size, spinning, children }) => (
  <div className={styles.loader}>
    <Spin indicator={<AryaLoading />} size={size} spinning={spinning}>
      {children}
    </Spin>
  </div>
);

export default Loader;
